import { Injectable } from "@angular/core";
import { HttpHeaders,HttpClient } from "@angular/common/http";

@Injectable()

export class TripService{
    constructor(private http:HttpClient)
    {
      console.log('instance created');
    }

    httpOptions ={
        headers: new HttpHeaders({'Content-Type':'application/json'})
    };

    getTrips(){
        return this.http.get('/trips');
    }

    getShipmentTrips(){
        let config = {
            headers: new HttpHeaders({'Content-Type':'application/json'})
          };
          config["params"] = {
            filter: JSON.stringify({where:{"tripType":"Shipment Trip"}})
          };
        return this.http.get('/trips', config);
    }

    getGeneralTrips(){
        let config = {
            headers: new HttpHeaders({'Content-Type':'application/json'})
          };
          config["params"] = {
            filter: JSON.stringify({where:{"tripType":"General Trip"}})
          };
        return this.http.get('/trips', config);
    }

    getDriverTrips(driverId:string, include:any){
        let config = {
            headers: new HttpHeaders({'Content-Type':'application/json'})
        };
        config["params"] = {
            filter: JSON.stringify({include:include, where:{"driverId":driverId, tripType:{"neq":"Shipment Trip"}}})
        };
        return this.http.get('/trips', config);
    }

    getTripById(tripId:string)
    {
        return this.http.get('/trips/'+tripId,this.httpOptions);
    }
    
    getTripRouteById(routeId:string)
    {
        return this.http.get('/routes/'+routeId,this.httpOptions);
    }
    getTripByDate(year:string, month:string)
    {
        let config = {
            headers: new HttpHeaders({'Content-Type':'application/json'})
          };
          config["params"] = {
            filter: JSON.stringify({where:{"tripType":"General Trip"}})
          };

        let body ='tripyear='+year+'&tripmonth='+month;
        return this.http.get('/trips?'+body, config);
    }
    deleteTrip(data) {
        return this.http.delete('/trips/' + data.id);
    }
    createTrip(data) {
        let body = JSON.stringify(data);
        return this.http.post('/trips/', body, this.httpOptions);
    }
    updateTrip(data) {
        let body = JSON.stringify(data);
        return this.http.put('/trips/' + data.id, body, this.httpOptions);
    }

    getShipmentTripsByVehicleId(vehicleId): any {
        let config = { headers: new HttpHeaders({'Content-Type':'application/json'}) };
        config["params"] = {
            filter: JSON.stringify({ where:{ tripType: "Shipment Trip", vehicleId : vehicleId } })
          };
        return this.http.get('/trips', config);
    }

    getAnalytics(data){
        let config = {
          headers: new HttpHeaders({'Content-Type':'application/json'})
      };
      config["params"] = {
          filter: JSON.stringify({where:{"startDate	":data.startDate,"endDate":data.endDate}})
      };
      return this.http.get('/trips/getTripAnalytics', config);
      }

    getShipmentTripsByVehcileIdDate(vehicleId, mindate:Date, maxDate:Date): any {
        let config = { headers: new HttpHeaders({'Content-Type':'application/json'}) };
        config["params"] = {
            min:mindate.toISOString(),
            max: maxDate.toISOString()
          };
        return this.http.get('/trips/tripsByVehicleId/'+vehicleId, config);
    }

    getTripsByVehicleId(vehicleId): any {
        let config = { headers: new HttpHeaders({'Content-Type':'application/json'}) };
        config["params"] = {
            filter: JSON.stringify({ where:{ vehicleId : vehicleId } })
          };
        return this.http.get('/trips', config);
    }

    getTripPathByVehicleIdNTripId(vehicleId, tripId) {
        let config = { headers: new HttpHeaders({'Content-Type':'application/json'}) };
        
        return this.http.get('/trips/'+vehicleId+'/trip/'+tripId+'/path', config);
    }
}


// WEBPACK FOOTER //
// ./src/app/services/trips/trip.service.ts